module.exports = __webpack_public_path__ + "static/media/main.bea4208c.png";